import React from "react";
import useUploadFiles from "../../../hooks/useUploadFiles";

// components
// import { Modal } from "antd";
import Upload from "../../../component/modals/upload";
import Tab from "../../../component/ui/tabs/Tabs";
import TextInput from "../../../component/element/forms/TextInput";
import TextMultipleInput from "../../../component/element/forms/TextMultipleInput";

// types and state
import {
  ICreateService as Create,
  ICreateServiceError,
} from "../../../store/types/service";
import { create_service } from "../../../services/apis/services";
import { useAppDispatch, useAppSelector } from "../../../store";
import Modal from "../../../component/ui/modal";
import RichTextEditor from "../../../component/element/forms/RichTextEditor";

type ICreateService = {
  show: boolean;
  onCancel: () => void;
};

const CreateService: React.FC<ICreateService> = ({ show, onCancel }) => {
  const dispatch = useAppDispatch();
  const loading = useAppSelector(({ service }) => service.loading);
  const [data, dataSet] = React.useState<Create>({
    name: "",
    description: "",
    image: "",
    packages: [],
    price: "",
  });
  const [err, errSet] = React.useState<ICreateServiceError>({
    name: "",
    description: "",
    image: "",
    packages: "",
    price: "",
  });

  const { loader, uploadFile, deleteFiles } = useUploadFiles();

  const onsubmit = async () => {
    const errors: ICreateServiceError = {
      name: data.name.trim() ? "" : "error: this field is required",
      description: data.description.trim()
        ? ""
        : "error: this field is required",
      image: "",
      packages: data.packages.length
        ? ""
        : "error: this field is required",
      price: data.price.trim() ? "" : "error: this field is required",
    };
    errSet(errors);
    if (
      !data.name.trim() ||
      !data.description.trim() ||
      !data.price.trim() ||
      !data.packages.length
    ) {
      return;
    }

    const response = await create_service(data, dispatch);
    if (response) {
      dataSet({
        name: "",
        description: "",
        image: "",
        packages: [],
        price: "",
      });
      errSet({
        name: "",
        description: "",
        image: "",
        packages: "",
        price: "",
      });
      onCancel();
    }
  };

  return (
    <Modal
      title="Create Service"
      open={show}
      onClose={onCancel}
      onOkClick={onsubmit}
      variant="large"
      isLoading={loading}
    >
      <div className="space-y-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div>
            <Upload
              title="Upload Image"
              label="JPG or PNG"
              name="image"
              status={err.image}
              loading={loader}
              completed={Boolean(data.image)}
              imgPreview={data.image}
              onChange={async (fileOrFiles) => {
                const paths = await uploadFile(fileOrFiles as File, "services");
                if (paths.length > 0) {
                  const img_path = paths[0]?.base_url + "/" + paths[0]?.path;
                  dataSet((prev) => ({ ...prev, image: img_path }));
                }
              }}
              onDelete={async () => {
                if (data.image) {
                  const res = await deleteFiles(data.image);
                  if (res) {
                    dataSet((prev) => ({ ...prev, image: "" }));
                  }
                }
              }}
            />
          </div>
          <div>
            <div className="mb-3">
              <TextInput
                value={data.name}
                label="Name"
                name="name"
                placeholder="Service Name"
                type="text"
                status={err.name}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const { name, value } = e.target;
                  dataSet((prev) => ({ ...prev, [name]: value }));
                  errSet((prev) => ({ ...prev, [name]: undefined }));
                }}
              />
            </div>
            <div className="mb-3">
              <TextInput
                value={data.price}
                label="Price"
                name="price"
                placeholder="Service Price"
                type="number"
                status={err.price}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  const { name, value } = e.target;
                  dataSet((prev) => ({ ...prev, [name]: value }));
                  errSet((prev) => ({ ...prev, [name]: "" }));
                }}
              />
            </div>
            <div>
              <TextMultipleInput
                label="Packages"
                container="my-2"
                onChange={(res) => {
                  dataSet((prev) => ({
                    ...prev,
                    packages: [...prev.packages, res],
                  }));
                  errSet((prev) => ({ ...prev, packages: "" }));
                }}
              />

              <div>
                {data.packages.length > 0 && (
                  <div className="border p-1 rounded-lg flex flex-wrap gap-1">
                    {data.packages.map((item, index) => (
                      <Tab key={index} value={item} />
                    ))}
                  </div>
                )}
                {err.packages && (
                  <p className="mt-1 text-sm text-red-500">{err.packages}</p>
                )}
              </div>
            </div>
          </div>
        </div>

        <div>
          <RichTextEditor
            label="Description"
            value={data.description}
            error={err.description}
            onChange={(val) => {
              dataSet((prev) => ({ ...prev, description: val }));
              errSet((prev) => ({ ...prev, description: "" }));
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default CreateService;
